module.exports = __webpack_public_path__ + "img/icon_map_0_off_001.9d4811bc.png";